
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 24px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-top: 32px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 1.5rem;
  color: #333;
`;

export const Controls = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
`;

export const SearchInput = styled.input`
  padding: 10px 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  width: 250px;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Select = styled.select`
  padding: 10px 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

export const ExportButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;

  ${(props) => {
    switch (props.variant) {
      case 'all':
        return `
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
          }
        `;
      case 'completed':
        return `
          background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(39, 174, 96, 0.4);
          }
        `;
      case 'pending':
        return `
          background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(231, 76, 60, 0.4);
          }
        `;
      default:
        return '';
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background: white;
  border-radius: 12px;
  margin-top: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    background: #334455;
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    color: white;
    padding: 16px;
    text-align: right;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  td {
    padding: 14px 16px;
    border-bottom: 1px solid #e9ecef;
    text-align: center;
  }

  tr:hover {
    background: #f8f9fa;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const CourseHeaderCell = styled.th`
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important; */
  color: white !important;
  padding: 12px 8px !important;
  text-align: center !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  min-width: 100px;
  max-width: 120px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.3;

  &:hover {
    /* background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important; */
    background: #8699bd !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: rgba(255, 255, 255, 0);
    transition: all 0.3s ease;
  }

  &:hover::after {
    background: rgba(255, 255, 255, 0.7);
  }
`;

export const NameCell = styled.td`
  text-align: right !important;
  font-weight: 500;
  color: #333;
  min-width: 200px;
`;

export const SectorCell = styled.td`
  font-size: 0.85rem;
  color: #666;
  min-width: 120px;
`;

export const StatusIcon = styled.div`
  font-size: 1.5rem;
  font-weight: bold;

  ${(props) =>
    props.completed
      ? `
    color: #27ae60;
  `
      : `
    color: #e74c3c;
  `}
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const PaginationButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #e9ecef;
  background: ${(props) => (props.active ? '#667eea' : 'white')};
  color: ${(props) => (props.active ? 'white' : '#333')};
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: ${(props) => (props.active ? '#667eea' : '#f0f0f0')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PageInfo = styled.span`
  color: #666;
  font-size: 0.9rem;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: #999;

  p {
    margin: 0;
    font-size: 1.1rem;
  }
`;

export const LoadingState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: #667eea;
  font-size: 1.1rem;
`;